<template>
    <div v-if="!loading">
        <b-row>
            <b-col md="3" class="mb-2">
                <b-form-input v-model="parameters.searchTerm" placeholder="نام مجموعه" class="text-center" dir="ltr" />
            </b-col>
            <b-col md="2" class="mb-2">
                <b-button @click="getSmsChargesHistory" variant="primary" class="w-100">اعمال فیلتر</b-button>
            </b-col>
        </b-row>


        <b-card class="p-0" no-body>
            <b-overlay :show="loadingPage" variant="transparent" opacity="1" blur="3px" rounded="sm">
                <b-table responsive :items="chargesHistoryList" :fields="fields" class="mb-0">
                    <template #cell(createdAt)="data">
                        <div>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleDateString('fa-IR') }}
                            </span>
                            <span> - </span>
                            <span>
                                {{ new Date(data.item.createdAt).toLocaleTimeString('fa-IR').split(":").slice(0,
                                    2).join(":") }}
                            </span>
                        </div>
                    </template>
                    <template #cell(amount)="data">
                        {{ data.item.amount.toLocaleString('fa-IR') }}
                    </template>
                    <template #cell(status)="data">
                        <b-badge :variant="payment_StatusVariant(data.item.status)" pill>
                            {{ payment_Status(data.item.status) }}
                        </b-badge>
                    </template>
                </b-table>
            </b-overlay>
        </b-card>
        <b-pagination align="center" @input="getSmsChargesHistory" v-model="parameters.pageIndex"
            :total-rows="parameters.totalCount" :per-page="parameters.pageSize" />
    </div>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BImg, BAvatar, BTable, BPagination, BOverlay, BFormInput, BBadge } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BImg,
        BAvatar,
        BTable,
        BPagination,
        BFormInput,
        BOverlay,
        BBadge
    },
    data() {
        return {
            loading: true,
            loadingPage: false,
            chargesHistoryList: [],
            fields: [
                {
                    key: 'id',
                    label: 'شماره پیگیری',
                },
                {
                    key: 'storeName',
                    label: 'نام مجموعه',
                },
                {
                    key: 'createdAt',
                    label: 'تاریخ',
                },
                {
                    key: 'amount',
                    label: 'مبلغ (ریال)',
                },
                {
                    key: 'status',
                    label: 'وضعیت',
                },
                {
                    key: 'bankTransactionCode',
                    label: 'شماره تراکنش بانک',
                },
            ],
            parameters: {
                pageIndex: 1,
                pageSize: 12,
                totalCount: null,
                searchTerm: null
            },
        }
    },
    computed: {
        payment_Status() {
            return (status) => {
                if (status == 0) {
                    return 'در انتظار پرداخت'
                }
                if (status == 1) {
                    return 'پرداخت نشده'
                }
                if (status == 2) {
                    return 'پرداخت شده'
                }
            }
        },
        payment_StatusVariant() {
            return (status) => {
                if (status == 0) {
                    return 'light-warning'
                }
                if (status == 1) {
                    return 'light-danger'
                }
                if (status == 2) {
                    return 'light-success'
                }
            }
        },
    },
    methods: {
        getSmsChargesHistory() {
            this.loadingPage = true
            adminService.getSmsChargesHistory(this.parameters).then(({ data }) => {
                setTimeout(() => {
                    this.parameters.totalCount = data.totalCount
                    this.chargesHistoryList = data.items
                    this.loadingPage = false
                    this.loading = false
                }, 369)
            })
        },
    },
    mounted() {
        this.getSmsChargesHistory()
    },
};
</script>